export const isSomeObjectValueThruthy = obj => !!Object.values(obj)?.find(el => !!el);

export const hasMissingAffiliatedEntities = (entities, isLastPage) => {
  if (isLastPage && entities?.length) {
    return entities.some(({ affiliatedEntities }) => {
      return affiliatedEntities.every(entity => !entity.email);
    });
  }
};

export const checkAffEntitiesMissingForCurrentEntityError = (entities, currentEntityindex) => {
  if (entities?.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < entities.length; i++) {
      const { affiliatedEntities } = entities[i];
      if (affiliatedEntities.every(entity => !entity.email) && i === currentEntityindex) {
        return 'Please link or add at least one affiliated entity for this legal entity';
      }
    }
  }
};
